import { render, staticRenderFns } from "./bodyer-right.vue?vue&type=template&id=3484bf8f&scoped=true&"
import script from "./bodyer-right.vue?vue&type=script&lang=js&"
export * from "./bodyer-right.vue?vue&type=script&lang=js&"
import style0 from "./bodyer-right.vue?vue&type=style&index=0&id=3484bf8f&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484bf8f",
  null
  
)

export default component.exports